import React from 'react'
import styled from '@emotion/styled'
import { colors, font } from '@mobi/component-library/Foundations'
import { Constants } from '@mobi/settings/constants'
import { keys } from '@core/Services/Analytics/keys'
import { trackEvent } from '@core/Services/Analytics/track'
import { useResponsibleWageringMessage } from '../Hooks/useResponsibleWageringMessage'
import { ExternalLink } from './ExternalLink'

export const ResponsibleWageringBanner = () => {
  const message = useResponsibleWageringMessage()

  return (
    <ResponsibleWageringBannerStyled>
      <span>{message}</span>
      <span>SET A DEPOSIT LIMIT.</span>
      <span>
        <p>
          For free and confidential support call{' '}
          <strong>
            <a
              href={`tel:${Constants.GamblingHelpPhoneNumber}`}
              target='_blank'
              rel='noopener noreferrer'
            >
              {Constants.GamblingHelpPhoneNumber}
            </a>
          </strong>{' '}
          or visit{' '}
          <strong>
            <ExternalLink
              href={Constants.GamblingHelpOnlineURL}
              onClick={() => trackExitNavigation('gambling-help-online')}
            >
              gamblinghelponline.org.au
            </ExternalLink>
          </strong>
        </p>
      </span>
    </ResponsibleWageringBannerStyled>
  )
}

function trackExitNavigation(destination: string) {
  trackEvent(keys.navExit, { destination })
}

const ResponsibleWageringBannerStyled = styled.div({
  backgroundColor: colors.white,
  display: 'flex',
  flexDirection: 'column',
  margin: '0.5rem 0rem',
  minHeight: '3rem',
  padding: '1rem',
  textAlign: 'center',
  fontFamily: 'Roboto, sans-serif',

  'span:first-of-type': {
    ...font.size.xl2,
    fontWeight: 'bold',
  },

  'span:nth-of-type(2)': {
    ...font.size.xl,
  },

  'span:nth-of-type(3)': {
    ...font.size.xs,
  },
})
